import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActionCommand, ActionCommandService } from '../../../../services/action-command.service';
import { MenuStateService } from '../../../../services/menu-state.service';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-cash-closure',
  imports: [CommonModule, FormsModule, InputNumberModule, InputTextModule, ButtonModule],
  templateUrl: './cash-closure.component.html'
})
export class CashClosureComponent implements OnInit, OnDestroy, ActionCommand {
  
  // Valores recebidos no turno
  moneyReceived: number = 0;
  pixReceived: number = 0;
  creditCardReceived: number = 0;
  debitCardReceived: number = 0;
  checkReceived: number = 0;
  creditReceived: number = 0;
  bankTransferReceived: number = 0;
  voucherReceived: number = 0;
  depositReceived: number = 0;
  cashBackReceived: number = 0;

  constructor(
    @Inject(ActionCommandService) private actionCommandService: ActionCommandService,
    @Inject(MenuStateService) private menuStateService: MenuStateService,
    @Inject(MessageService) private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.registerCommands();
  }

  ngOnDestroy(): void {
    this.unregisterCommands();
  }

  private registerCommands(): void {
    // Registrar comando F1 para confirmar fechamento
    this.actionCommandService.registerCommand({
      getKey: () => 'F1',
      execute: () => this.confirmClosure(),
      getDescription: () => 'Confirmar Fechamento'
    });

    // Registrar comando ESC para voltar
    this.actionCommandService.registerCommand({
      getKey: () => 'ESC',
      execute: () => this.goBack(),
      getDescription: () => 'Voltar'
    });
  }

  private unregisterCommands(): void {
    this.actionCommandService.unregisterCommand('F1');
    this.actionCommandService.unregisterCommand('ESC');
  }

  get totalReceived(): number {
    return this.moneyReceived + 
           this.pixReceived + 
           this.creditCardReceived + 
           this.debitCardReceived + 
           this.checkReceived + 
           this.creditReceived + 
           this.bankTransferReceived + 
           this.voucherReceived + 
           this.depositReceived + 
           this.cashBackReceived;
  }

  confirmClosure(): void {
    // TODO: Implementar chamada à API para fechamento de caixa
    console.log('Fechando caixa com valores:', {
      moneyReceived: this.moneyReceived,
      pixReceived: this.pixReceived,
      creditCardReceived: this.creditCardReceived,
      debitCardReceived: this.debitCardReceived,
      checkReceived: this.checkReceived,
      creditReceived: this.creditReceived,
      bankTransferReceived: this.bankTransferReceived,
      voucherReceived: this.voucherReceived,
      depositReceived: this.depositReceived,
      cashBackReceived: this.cashBackReceived,
      totalReceived: this.totalReceived,
      pdvId: localStorage.getItem('pdvId')
    });

    // Simulação - remover quando implementar API
    this.messageService.add({
      severity: 'success',
      summary: 'Sucesso!',
      detail: 'Fechamento de caixa realizado com sucesso!',
      life: 3000
    });

    // Limpar formulário
    this.clearForm();
  }

  clearForm(): void {
    this.moneyReceived = 0;
    this.pixReceived = 0;
    this.creditCardReceived = 0;
    this.debitCardReceived = 0;
    this.checkReceived = 0;
    this.creditReceived = 0;
    this.bankTransferReceived = 0;
    this.voucherReceived = 0;
    this.depositReceived = 0;
    this.cashBackReceived = 0;
  }

  goBack(): void {
    this.menuStateService.goBackToMainMenu();
  }

  // Implementação da interface ActionCommand
  getKey(): string {
    return 'F1';
  }

  execute(): void {
    this.confirmClosure();
  }

  getDescription(): string {
    return 'Confirmar Fechamento';
  }
}
